import { PricelistType } from '@g2-shared/api-client/generated/pricing-app';

export const PriceListTypeOptions = {
  [PricelistType.GENERAL]: 'General',
  [PricelistType.FOR_AGENT]: 'For_agent',
  [PricelistType.FOR_LOCATION]: 'For_location',
  [PricelistType.FOR_CLIENT]: 'For_client',
};
